import { render } from "./App.vue?vue&type=template&id=10439d3b&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=10439d3b&scoped=true&lang=css"

import exportComponent from "../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10439d3b"]])

export default __exports__